import { Flex, Text } from '@chakra-ui/react';
import { ButtonText, OutlineCard } from '@morressier/alembic';
import { useState } from 'react';
import ReviewDetailsModal from 'src/components/Adjudications/ReviewDetailsModal';
import { recommendationBadges } from 'src/components/Review/Badges';
import {
  IAdjudicationReview,
  IExpertFirstAssessment
} from '../adjudicationType';

const ReviewDetailsCard = ({
  data,
  index
}: {
  data: IAdjudicationReview;
  index: number;
}) => {
  const [openReviewDetailsModal, setOpenReviewDetailsModal] = useState(false);

  const review = [
    data.firstAssessment,
    ...data.revisionAssessmentHistory
  ].pop() as IExpertFirstAssessment;

  return (
    <>
      {openReviewDetailsModal && (
        <ReviewDetailsModal
          data={{
            ...data,
            firstAssessment: review
          }}
          isOpen={openReviewDetailsModal}
          onClose={() => setOpenReviewDetailsModal(false)}
          index={index}
        />
      )}
      <OutlineCard borderColor={'transparent'} padding={3}>
        <Flex direction={'column'} gap={3} alignItems={'flex-start'}>
          <Flex gap={3} alignItems="end">
            <Text textStyle="headingItem">Recommendation:</Text>
            {review?.recommendation &&
              recommendationBadges[review?.recommendation]}
          </Flex>
          <Text textStyle="textBody" noOfLines={[1, 2, 3]}>
            {review?.feedbackForAuthors?.moderated
              ? review?.feedbackForAuthors?.moderated
              : review?.feedbackForAuthors?.original}
          </Text>
          <ButtonText onClick={() => setOpenReviewDetailsModal(true)}>
            Read Review
          </ButtonText>
        </Flex>
      </OutlineCard>
    </>
  );
};

export default ReviewDetailsCard;
